define('plugin/news/NewsPlugin',['require','lib/plugin/PluginAbstract','plugin/news/controller/NewsController','plugin/news/collection/NewsCollection','plugin/news/view/NewsModuleView','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var NewsController = require('plugin/news/controller/NewsController');
    var NewsCollection = require('plugin/news/collection/NewsCollection');
    var NewsModuleView = require('plugin/news/view/NewsModuleView');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _newsModuleRegions: {
            newsModule: '#sb_news_module'
        },
        _collection: null,

        initialize: function () {
            this._collection = new NewsCollection();

            var newsRouter = new AppRouter({
                appRoutes: {
                    'news': 'index',
                    'news/:id': 'view'
                },
                menuItem: 'news',
                controller: new NewsController({
                    app: this.getOption('app')
                })
            });
        },

        initModules: function (view) {
            _.each(this._newsModuleRegions, function (selector, newsModuleRegion) {
                view.addRegion(newsModuleRegion, selector);
            });

            if (view.newsModule.$el.length) {
                view.newsModule.show(new NewsModuleView({
                    collection : this._collection
                }));
                this._collection.load();
            }
        }

    });

});
